import React, { useState, useEffect } from 'react';
import _axios from "../../../../httpService";
import { prefixUrl } from "../../../../utils/utilsData";
import { toast } from "react-toastify";
import { FilterIcon } from '../ExportSVG';
import CustomTable from '../../../CustomTable/CustomTable';
import Loader from '../../../Loader';
import DynaDatePicker from '../../DynaView/DynaDatePicker';
import DynaSelectBox from '../../DynaView/DynaSelectBox';
import './DailyInsurance.scss';

const DailyInsurance = () => {
  const [initialData, setInitialData] = useState({});
  const [personTypeList, setPersonTypeList] = useState([]);
  const [insuranceTypeList, setInsuranceTypeList] = useState([]);
  const [dateFilter, setDateFilter] = useState({
    endDate: "",
    startDate: "",
    insuranceTypeId: "",
    personType: ""
  });
  const [isLoad, setIsLoad] = useState(false);

  const getInitialData = () => {
    _axios.get(prefixUrl() + `/insurance/?request=dailyInsuranceTable&endDate=${dateFilter?.endDate}&startDate=${dateFilter?.startDate}&insuranceTypeId=${dateFilter?.insuranceTypeId}&personType=${dateFilter?.personType}`).then((response) => {
      if (response.data.status) {
        setInitialData(response.data.data);
        setIsLoad(true)
      } else {
        toast.error(response.data.message);
      }
    })
  }

  const getPersonTypeData = () => {
    _axios.get(prefixUrl() + "/insurance/?request=insurancePersonTypeList").then((response) => {
      if (response.data.status) {
        setPersonTypeList(response.data.data);
      } else {
        toast.error(response.data.message);
      }
    })
  }

  const getInsuranceTypeData = () => {
    _axios.get(prefixUrl() + "/insurance/?request=insuranceTypeList").then((response) => {
      if (response.data.status) {
        setInsuranceTypeList(response.data.data);
      } else {
        toast.error(response.data.message);
      }
    })
  }

  useEffect(() => {
    getInitialData();
    getPersonTypeData();
    getInsuranceTypeData();
  }, []);

  try {
    return isLoad ?
      (
        <section className='daily-insurance'>
          <div className='filter-section'>
            <DynaDatePicker
              label={"از تاریخ"}
              name={"startDate"}
              className={"solid-dyna-input"}
              value={dateFilter?.startDate}
              setDataFromComponent={(data) => {
                setDateFilter({ ...dateFilter, ...data })
              }}
            />
            <DynaDatePicker
              label={"تا تاریخ"}
              name={"endDate"}
              className={"solid-dyna-input"}
              value={dateFilter?.endDate}
              setDataFromComponent={(data) => {
                setDateFilter({ ...dateFilter, ...data })
              }}
            />
            <DynaSelectBox
              options={insuranceTypeList}
              hasFilter={false}
              label={"نوع بیمه نامه"}
              className={"solid-dyna-input"}
              value={dateFilter?.insuranceTypeId}
              hasAllOption={true}
              onChange={(data) => setDateFilter({ ...dateFilter, insuranceTypeId: data.value })}
            />
            <DynaSelectBox
              options={personTypeList}
              hasFilter={false}
              label={"نوع شخص"}
              className={"solid-dyna-input"}
              value={dateFilter?.personType}
              hasAllOption={true}
              onChange={(data) => setDateFilter({ ...dateFilter, personType: data.value })}
            />
            <button onClick={getInitialData} className="filter-btn">
              <FilterIcon />
            </button>
          </div>
          <CustomTable tableData={initialData} hasOperation={false} />
        </section>
      ) : (
        <Loader />
      );
  } catch (e) {
    return <>{e.toLocaleString()}</>
  }
};

export default DailyInsurance;